import { __classPrivateFieldSet, __classPrivateFieldGet } from '../../external_node_modules/tslib/tslib.es6.js';
import { PriceFormatter as p } from '../../external_node_modules/@wg/wows-formatter/core/Price/index.js';
import { PLATFORMS } from '../../constants/platforms.js';
import { PRODUCT_PRICE_TYPES } from '../../constants/productPriceType.js';

var _ProductEntity_instances, _ProductEntity_product, _ProductEntity_platform, _ProductEntity_priceFormatter, _ProductEntity_customPersonalLimit, _ProductEntity_customPersonalCount, _ProductEntity_quantity, _ProductEntity_language, _ProductEntity_country, _ProductEntity_commonCount_get, _ProductEntity_commonLimit_get, _ProductEntity_personalCount_get, _ProductEntity_personalLimit_get;
class ProductEntity {
    constructor(product, platform, language, country) {
        _ProductEntity_instances.add(this);
        _ProductEntity_product.set(this, void 0);
        _ProductEntity_platform.set(this, void 0);
        _ProductEntity_priceFormatter.set(this, void 0);
        _ProductEntity_customPersonalLimit.set(this, 0);
        _ProductEntity_customPersonalCount.set(this, 0);
        _ProductEntity_quantity.set(this, 1);
        _ProductEntity_language.set(this, void 0);
        _ProductEntity_country.set(this, void 0);
        __classPrivateFieldSet(this, _ProductEntity_product, product, "f");
        __classPrivateFieldSet(this, _ProductEntity_platform, platform, "f");
        __classPrivateFieldSet(this, _ProductEntity_language, language, "f");
        __classPrivateFieldSet(this, _ProductEntity_country, country, "f");
        const { currency, price, originalPrice, discount, useMinorUnits } = preparePlatformPrice(__classPrivateFieldGet(this, _ProductEntity_product, "f"), platform);
        __classPrivateFieldSet(this, _ProductEntity_priceFormatter, new p(currency, price, originalPrice, discount, language, useMinorUnits, country), "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").id;
    }
    get code() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").code;
    }
    get externalProductId() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").externalProductId;
    }
    get categories() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").categories;
    }
    get clientPaymentMethods() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").clientPaymentMethods || [];
    }
    get isPurchasable() {
        let isPurchasable = __classPrivateFieldGet(this, _ProductEntity_product, "f").isPurchasable;
        if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.EGS) {
            isPurchasable = __classPrivateFieldGet(this, _ProductEntity_product, "f").hasOwnProperty('bAvailableForPurchase')
                ? toNumber(__classPrivateFieldGet(this, _ProductEntity_product, "f").bAvailableForPurchase)
                : isPurchasable;
        }
        if (isPurchasable && this.availableCommonCount !== null) {
            isPurchasable = this.availableCommonCount > 0;
        }
        if (isPurchasable && this.availablePersonalCount !== null) {
            isPurchasable = this.availablePersonalCount > 0;
        }
        if (isPurchasable && __classPrivateFieldGet(this, _ProductEntity_product, "f").limitedQuantity) {
            isPurchasable = __classPrivateFieldGet(this, _ProductEntity_product, "f").limitedQuantity.purchaseAllowed;
        }
        return !!isPurchasable;
    }
    get isProcessing() {
        let isProcessing = false;
        if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.WIN_STORE) {
            isProcessing = __classPrivateFieldGet(this, _ProductEntity_product, "f").inProgress;
        }
        return isProcessing;
    }
    get availableCommonCount() {
        if (__classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_commonLimit_get) !== null) {
            return __classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_commonLimit_get) - (__classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_commonCount_get) || 0);
        }
        return null;
    }
    get availablePersonalCount() {
        if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.EGS) {
            const limit = toNumber(__classPrivateFieldGet(this, _ProductEntity_product, "f").purchaseLimit);
            return limit > 0 ? limit : null;
        }
        if (__classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_personalLimit_get) !== null) {
            return __classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_personalLimit_get) - (__classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_personalCount_get) || 0);
        }
        return null;
    }
    get currency() {
        if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.WIN_STORE) {
            return __classPrivateFieldGet(this, _ProductEntity_product, "f").currencyCode;
        }
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").currency;
    }
    get price() {
        return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").price;
    }
    get originalPrice() {
        return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").originalPrice;
    }
    get discount() {
        return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").discount;
    }
    get formattedPrice() {
        if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.WIN_STORE) {
            return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedRawPrice;
        }
        return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedPrice;
    }
    get formattedOriginalPrice() {
        if (__classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedPrice === __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedOriginalPrice) {
            return null;
        }
        if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.WIN_STORE) {
            return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedRawOriginalPrice;
        }
        return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedOriginalPrice;
    }
    get formattedDiscount() {
        return __classPrivateFieldGet(this, _ProductEntity_priceFormatter, "f").formattedDiscount;
    }
    get tileSize() {
        return normalizeSizeInGrid(__classPrivateFieldGet(this, _ProductEntity_product, "f").sizeInGrid);
    }
    get tileSizeInFeaturing() {
        return normalizeSizeInGrid(__classPrivateFieldGet(this, _ProductEntity_product, "f").sizeInGridFeaturing);
    }
    get tileImageUrl() {
        return getProductTileImageUrl(__classPrivateFieldGet(this, _ProductEntity_product, "f").sizeInGrid, __classPrivateFieldGet(this, _ProductEntity_product, "f").images);
    }
    get tileImageUrlInFeaturing() {
        return getProductTileImageUrl(__classPrivateFieldGet(this, _ProductEntity_product, "f").sizeInGridFeaturing, __classPrivateFieldGet(this, _ProductEntity_product, "f").images);
    }
    get productImageUrl() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").images.big || __classPrivateFieldGet(this, _ProductEntity_product, "f").images.default;
    }
    get productBackgroundUrl() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").images.background;
    }
    get title() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").title;
    }
    get description() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").description;
    }
    get productContentDescription() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").productContentDescription;
    }
    get entitlements() {
        var _a;
        if (!__classPrivateFieldGet(this, _ProductEntity_product, "f").disableAutoDescription && ((_a = __classPrivateFieldGet(this, _ProductEntity_product, "f").entitlements) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return __classPrivateFieldGet(this, _ProductEntity_product, "f").entitlements;
        }
        return null;
    }
    get descriptionAdditional() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").descriptionAdditional;
    }
    get additionalInformation() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").additionalInformation;
    }
    get decoration() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").decoration;
    }
    get promoLabels() {
        return Array.isArray(__classPrivateFieldGet(this, _ProductEntity_product, "f").promoLabels) ? __classPrivateFieldGet(this, _ProductEntity_product, "f").promoLabels[0] : __classPrivateFieldGet(this, _ProductEntity_product, "f").promoLabels;
    }
    get promoTimerActiveTill() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").promoTimerActiveTill ? new Date(__classPrivateFieldGet(this, _ProductEntity_product, "f").promoTimerActiveTill) : null;
    }
    get displayGroup() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").displayGroup;
    }
    get raw() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f");
    }
    get customization() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").customization;
    }
    get showDiscountLabel() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").showDiscountLabel;
    }
    get variablePriceSettings() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").variablePriceSettings;
    }
    get isVariablePriceProduct() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").priceType === PRODUCT_PRICE_TYPES.VARIABLE;
    }
    get quantity() {
        return __classPrivateFieldGet(this, _ProductEntity_quantity, "f");
    }
    get externalShopPurchaseUrl() {
        return __classPrivateFieldGet(this, _ProductEntity_product, "f").externalShopPurchaseUrl;
    }
    updateTileSize(sizeInGrid) {
        __classPrivateFieldGet(this, _ProductEntity_product, "f").sizeInGrid = sizeInGrid;
    }
    changePersonalLimit(personalLimit) {
        __classPrivateFieldSet(this, _ProductEntity_customPersonalLimit, personalLimit, "f");
    }
    changePersonalCount(personalCount) {
        __classPrivateFieldSet(this, _ProductEntity_customPersonalCount, personalCount, "f");
    }
    updateLimitAfterSuccessPurchase() {
        __classPrivateFieldSet(this, _ProductEntity_customPersonalCount, __classPrivateFieldGet(this, _ProductEntity_instances, "a", _ProductEntity_personalCount_get), "f");
        __classPrivateFieldSet(this, _ProductEntity_customPersonalCount, __classPrivateFieldGet(this, _ProductEntity_customPersonalCount, "f") + 1, "f");
    }
    updateQuantity(quantity) {
        if (!this.isVariablePriceProduct) {
            return;
        }
        __classPrivateFieldSet(this, _ProductEntity_quantity, quantity, "f");
    }
    updateVariableProductPrice(variablePriceData) {
        const useMinorUnits = __classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.EGS;
        __classPrivateFieldSet(this, _ProductEntity_priceFormatter, new p(variablePriceData.price.realPrice.currencyCode, variablePriceData.price.realPrice.amount, variablePriceData.price.realPrice.originalAmount, variablePriceData.price.realPrice.discount.amount, __classPrivateFieldGet(this, _ProductEntity_language, "f"), useMinorUnits, __classPrivateFieldGet(this, _ProductEntity_country, "f")), "f");
    }
}
_ProductEntity_product = new WeakMap(), _ProductEntity_platform = new WeakMap(), _ProductEntity_priceFormatter = new WeakMap(), _ProductEntity_customPersonalLimit = new WeakMap(), _ProductEntity_customPersonalCount = new WeakMap(), _ProductEntity_quantity = new WeakMap(), _ProductEntity_language = new WeakMap(), _ProductEntity_country = new WeakMap(), _ProductEntity_instances = new WeakSet(), _ProductEntity_commonCount_get = function _ProductEntity_commonCount_get() {
    var _a;
    return ((_a = __classPrivateFieldGet(this, _ProductEntity_product, "f").limitedQuantity) === null || _a === void 0 ? void 0 : _a.commonCount) || null;
}, _ProductEntity_commonLimit_get = function _ProductEntity_commonLimit_get() {
    var _a;
    return ((_a = __classPrivateFieldGet(this, _ProductEntity_product, "f").limitedQuantity) === null || _a === void 0 ? void 0 : _a.commonLimit) || null;
}, _ProductEntity_personalCount_get = function _ProductEntity_personalCount_get() {
    var _a;
    let personalCount = ((_a = __classPrivateFieldGet(this, _ProductEntity_product, "f").limitedQuantity) === null || _a === void 0 ? void 0 : _a.personalCount) || null;
    if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.EGS) {
        personalCount = toNumber(__classPrivateFieldGet(this, _ProductEntity_product, "f").bAvailableForPurchase) || null;
    }
    return __classPrivateFieldGet(this, _ProductEntity_customPersonalCount, "f") || personalCount;
}, _ProductEntity_personalLimit_get = function _ProductEntity_personalLimit_get() {
    var _a;
    let personalLimit = ((_a = __classPrivateFieldGet(this, _ProductEntity_product, "f").limitedQuantity) === null || _a === void 0 ? void 0 : _a.personalLimit) || null;
    if (__classPrivateFieldGet(this, _ProductEntity_platform, "f") === PLATFORMS.EGS) {
        personalLimit = toNumber(__classPrivateFieldGet(this, _ProductEntity_product, "f").purchaseLimit) || null;
        personalLimit = personalLimit === -1 ? null : personalLimit;
    }
    return __classPrivateFieldGet(this, _ProductEntity_customPersonalLimit, "f") || personalLimit;
};
function toNumber(text) {
    return parseInt(text, 10);
}
function normalizeSizeInGrid(name) {
    return name.replace('/', '');
}
function normalizeWinStorePrice(price) {
    if (!price) {
        return 0;
    }
    const [, normalizedPrice = ''] = price.replace(/\s/g, '').match(/(\d[\d,.]+)/) || [];
    return normalizedPrice;
}
function preparePlatformPrice(product, platform) {
    var _a, _b;
    let useMinorUnits = false;
    let { currency, price, originalPrice, discount } = product;
    if (platform === PLATFORMS.WIN_STORE) {
        currency = product.currencyCode;
        price = normalizeWinStorePrice((_a = product.salePrice) !== null && _a !== void 0 ? _a : product.price);
        originalPrice = normalizeWinStorePrice((_b = product.salePrice) !== null && _b !== void 0 ? _b : null);
    }
    if (platform === PLATFORMS.EGS) {
        useMinorUnits = true;
        currency = product.currencyCode;
        price = product.currentPrice;
        originalPrice = product.currentPrice === product.originalPrice ? null : product.originalPrice;
        if (originalPrice) {
            product.discountPercentage = 100 - Math.round((product.currentPrice / product.originalPrice) * 100);
            if (product.discountPercentage) {
                discount = product.discountPercentage;
            }
        }
    }
    return {
        currency,
        price,
        originalPrice,
        discount,
        useMinorUnits,
    };
}
function getProductTileImageUrl(sizeInGrid, images) {
    const imageSizeMap = {
        '1': 'grid1',
        '1/4': 'grid14',
        '3/4': 'grid34',
        '1/2': 'grid12',
        '1/3': 'grid13',
        '2/3': 'grid23',
    };
    const tileImageKey = imageSizeMap[sizeInGrid];
    return images[tileImageKey] || images.default;
}

export { ProductEntity };
//# sourceMappingURL=product.entity.js.map
